export default "__VITE_ASSET__Mxp2fVrr__"